import { ChildProps } from '@apollo/client/react/hoc';
import { gql } from '@apollo/client';
import React from 'react';
import I81n from 'i18n-js';

import { CoreCategoryBestSellersSearch, Item2TitleData } from '../schemas/rql';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { Paths } from './shared/url_helpers';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';

interface IProps {
  cspId: string;
  subcategory: Item2TitleData.Categories;
  onLoad: Function;
  subcategoryRankings: Object;
  bestSellerThreshold: number;
}

export function BestSellerRank(props: ChildProps<IProps, CoreCategoryBestSellersSearch.Query>) {
  React.useEffect(() => {
    if (!props.data.cspSearch?.resultIds) { return; }

    props.onLoad({ ...props.subcategoryRankings, [props.subcategory.id]: cspRanking });
  }, [props.data.cspSearch?.resultIds, props.subcategory.id, props.onLoad]);

  if (!props.data?.cspSearch) { return null; }

  const topCspIds = props.data.cspSearch.resultIds;

  const indexOfCspId = topCspIds.indexOf(props.cspId);
  const cspIsRanked = indexOfCspId !== -1;
  const cspRanking = indexOfCspId + 1;

  if (!cspIsRanked) { return null; }

  return (
    <CoreLink
      to={Paths.categoryTopProducts.expand({
        rootCategory: props.subcategory.rootSlug,
        childCategory: props.subcategory.slug,
      })}
      className="product-badge__link"
    >
      {I81n.t('discovery.item2Layout.bestSellerBadge.linkText', {
        rank: cspRanking,
        category: props.subcategory.name,
      })}
    </CoreLink>
  );
}

const withQuery = withGraphql<IProps, CoreCategoryBestSellersSearch.Query>(
  gql`
    query Core_Category_BestSellersSearch(
      $categoryUuids: [String],
      $bestSellerThreshold: Int,
    ){
      cspSearch(input: {
        sort: RECENT_ORDERS_COUNT_DESC,
        limit: $bestSellerThreshold,
        categoryUuids: $categoryUuids
      }) {
        resultIds
      }
    }
  `,
  {
    options: (ownProps) => {
      return {
        errorPolicy: 'all',
        ssr: false,
        variables: {
          categoryUuids: [ownProps.subcategory.id],
          bestSellerThreshold: [ownProps.bestSellerThreshold],
        },
      };
    },
  },
);

export default withQuery(BestSellerRank);
